import {isNullOrUndefined} from 'util';

export enum ClientErrorCode {
    ERR001,
    ERR004,
    ERR005,
    ERR010,
    ERR012,
    ERR025,
    ERR028,
    ERR044,
    ERR045,
    ERR070,
    ERR074,
    ERR080,
    ERR084,
    ERR089,
    ERR104,
    ERR105,
    ERR114,
    ERR115,
    ERR121,
    ERR124,
    ERR314,
    ERR315,
    ERR316,
    ERR317,
    ERR319,
    ERR321,
    ERR323,
    ERR353,
    ERR354,
    ERR364,
    ERR372,
    ERR375,
    ERR376,
    ERR378,
    ERR379,
    ERR382,
    ERR103
}

export function getClientErrorCodeByServerCode(code: string): ClientErrorCode {
    let clientErrorCode: ClientErrorCode = ClientErrorCode[code];

    return isNullOrUndefined(clientErrorCode)
        ? ClientErrorCode.ERR001
        : clientErrorCode;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/core/http/entity/client.error.code.ts